import { useNavigate } from "react-router-dom";
import EmptyTable from "../EmptyTable";
import Loader from "../Loader";

const SchoolsTable = ({ loading, data, ownerId }) => {
  const navigate = useNavigate();

  function handleNavigateToSchool(params) {
    navigate(`/${params?.schoolId}/dashboard`);
  }

  // function handleNavigateToOwner(params) {
  //   navigate(`/schools?selected=${params?.ownerId?.userId}`);
  // }

  return (
    <div className="table_wrapper">
      <div className="min-w-[900px]">
        {/* table header */}
        <div className="grid grid-cols-8 border-b">
          <div className="col-span-3 border-r p-3">
            <h5 className="font-semibold text-sm">Name</h5>
          </div>

          <div className="border-r p-3">
            <h5 className="font-semibold text-sm">State</h5>
          </div>

          <div className="p-3 border-r col-span-2">
            <h5 className="font-semibold text-sm">Email</h5>
          </div>

          <div className="p-3 border-r">
            <h5 className="font-semibold text-sm">Phone</h5>
          </div>

          <div className="p-3">
            <h5 className="font-semibold text-sm">Date Joined</h5>
          </div>
        </div>

        {loading ? <Loader loading={loading} /> : null}

        {!loading && !data?.length ? (
          <EmptyTable
            //   image={subjectBookImage}
            message={"No teacher record found"}
          />
        ) : null}

        {/* Table body */}
        {data?.map((item, i) => (
          <div
            className={`grid grid-cols-8 border-b table_row hover:active_table_row ${
              ownerId === item?.ownerId ? "active_table_row" : ""
            }`}
            key={i}
          >
            <div
              className="col-span-3 border-r p-3"
              onClick={() => handleNavigateToSchool(item)}
            >
              <p className="text-independence text-sm capitalize underline hover:font-semibold">
                {item?.name}
              </p>
            </div>

            <div
              className="border-r p-3"
              // onClick={() => handleNavigateToOwner(item)}
            >
              <p className="text-independence text-sm capitalize underline hover:font-semibold">
                {item?.state}
              </p>
            </div>

            <div className="p-3 border-r col-span-2">
              <p className="text-independence text-sm">{item?.email}</p>
            </div>

            <div className="p-3 border-r">
              <p className="text-independence text-sm capitalize">
                {item?.phone}
              </p>
            </div>

            <div className="p-3">
              <p className="text-independence text-sm">
                {new Date(item?.createdAt)?.toLocaleDateString()}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default SchoolsTable;
